module.exports = __webpack_public_path__ + "img/about4.589bd443.jpg";